import React from "react";

import { ColorDisabled, IgTypography } from "@intelligems/ig-theme";
import { hexToRgbA } from "@intelligems/ig-utils";
import { Box, Grid } from "@mui/material";

import { ChangeLogProps, formatText } from "../utils";

export const CreatedKeyValueLine = ({
  k,
  value,
  dontFormat,
}: ChangeLogProps) => {
  return (
    <Grid container item className={"add-key-value-line"}>
      <Box
        alignItems={"center"}
        sx={{
          padding: "2px 16px 2px 16px",
          width: "100%",
          borderRadius: "5px",
          border: `1px solid ${hexToRgbA(ColorDisabled.main, 0.4)}`,
        }}
      >
        <IgTypography sx={{ fontWeight: 600 }}>{formatText(k, k)}</IgTypography>
        <IgTypography> set to </IgTypography>
        <IgTypography sx={{ fontWeight: 600 }}>
          {dontFormat ? `${value}` : formatText(k, value)}
        </IgTypography>
      </Box>
    </Grid>
  );
};
